module.exports = __webpack_public_path__ + "static/media/dragIcon.0504a148.svg";